// extracted by mini-css-extract-plugin
module.exports = {"ant-select-auto-complete":"ant-select-auto-complete","ant-select-clear":"ant-select-clear"};